export interface EmailVerificationState {
  token: string;
  email: string;
  rememberMe: boolean;
  expiresAt: string;
  resendAvailableAt: string;
  serverTime: string;
  clientReceivedAt: number;
  /**
   * "sign_in": a verified account confirming a password sign-in.
   * "email" (or absent): a new address being verified.
   */
  reason?: "sign_in" | "email";
}

const KEY = "emailVerificationState";

export function getEmailVerificationState(): EmailVerificationState | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as EmailVerificationState) : null;
  } catch {
    return null;
  }
}

export function setEmailVerificationState(state: EmailVerificationState) {
  sessionStorage.setItem(KEY, JSON.stringify(state));
}

export function clearEmailVerificationState() {
  sessionStorage.removeItem(KEY);
}
